import colors from '@/styles/colors'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import zIndex from '@mui/material/styles/zIndex'
import { transform } from 'typescript'

export const UploadContainer = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  '& .tab': {
    flex: 1,
    color: colors.darkGrey,
    borderRadius: 0,
    fontSize: 13,
    height: 50,
    '&.active': {
      borderBottom: `2px solid ${colors.blue}`,
      color: colors.blue,
    },
  },
  '& .list-wrapper': {
    overflow: 'auto',
    flex: 1,
  },
  '& .helper': {
    padding: 16,
    backgroundColor: `${colors.blue}55`,
  },
  '& .photo-item': {
    borderLeft: `4px solid white`,
    borderBottom: `1px solid ${colors.veryLightGrey}`,
    cursor: 'pointer',
    '&.active': {
      borderLeft: `4px solid ${colors.yellow}`,
      boxShadow: '0 1px 2px rgba(0,0,0,.1)',
    },
  },
  '& .preview': {
    height: 150,
    display: 'flex',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 4,
    },
  },
})

export const EgosContainer = styled(Box)({
  backgroundColor: 'white',
  height: '100%',
  display: 'flex',
  flex: 1,
  paddingBottom: '60px',
  flexDirection: 'column',
  '& .photo-item': {
    position: 'relative',
  },
  '& .checked': {
    backgroundColor: 'white',
    borderRadius: '50%',
    position: 'absolute',
    top: 10,
    right: 10,
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

export const UploadPhotoItem = styled(Box)(({ photo }: { photo: string }) => ({
  backgroundImage: `url(${photo})`,
  backgroundSize: 'cover',
  height: 0,
  paddingBottom: '100%',
  marginTop: -16,
  marginBottom: 16,
  borderRadius: 10,
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',
  '&:hover': {
    boxShadow: '0 5px 15px 0px #0000001A',
  },
  '& .checked-overlay': {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,

    height: '120px',
    background: 'linear-gradient(180deg, #00000066, #00000000)',
  },
}))

export const SelectTopicContainer = styled(Box)(({ theme }) => ({
  background: colors.gradients.selectTopics,
  overflow: 'hidden',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  position: 'relative',
  [theme.breakpoints.down('lg')]: {
    paddingLeft: 20,
  },
  '& .header': {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 8px 15px 20px',
  },

  '& .footer-container': {
    borderRadius: '8px',
    display: 'flex',
    marginTop: '16px',
  },

  '& .footer-content': {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px',
    background: 'linear-gradient(180deg , #161719 , #1D1E21)',
    borderRadius: '8px',
    margin: '0px 16px 16px 16px',
  },
}))
